import { render, staticRenderFns } from "./ScaCard.vue?vue&type=template&id=6df8fc38&scoped=true&"
import script from "./ScaCard.vue?vue&type=script&lang=ts&"
export * from "./ScaCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScaCard.vue?vue&type=style&index=0&id=6df8fc38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8fc38",
  null
  
)

export default component.exports